import styled from 'styled-components';
import { FIELD_HEIGHT } from '../../../DirectBookingEngine.styles';

// Flex, because a form-group of floated label/input columns collapses to zero height
// in a block parent and swallows the gap between the rows.
export const ColorFieldsStyled = styled.div`
  display: flex;
  flex-direction: column;

  .form-field-container {
    margin-bottom: 18px;
  }

  .control-label {
    color: #3a3a52;
    font-weight: 400;
  }
`;

export const ColorFieldRowStyled = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

// One flat shell around the hash and the input so they read as a single control.
// Bootstrap's own input-group cannot: it lays out as a table and paints the addon as a gray block with its own borders.

export const ColorInputStyled = styled.div`
  align-items: center;
  background: #fbfbfd;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  display: flex;
  flex-grow: 1;
  height: ${FIELD_HEIGHT};
  overflow: hidden;

  .form-control {
    background: none;
    border: 0;
    box-shadow: none;
    height: 100%;
  }
`;

export const ColorHashStyled = styled.span`
  align-items: center;
  align-self: stretch;
  border-right: 1px solid #e5e7eb;
  color: #9ca3af;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  width: 40px;
`;

export const ColorSwatchStyled = styled.input`
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
  height: ${FIELD_HEIGHT};
  padding: 0;
  width: ${FIELD_HEIGHT};

  &::-webkit-color-swatch-wrapper {
    padding: 2px;
  }

  &::-webkit-color-swatch,
  &::-moz-color-swatch {
    border: 0;
    border-radius: 4px;
  }
`;

export const BrandColorsRowStyled = styled.div`
  align-items: center;
  display: flex;

  & > .tooltip-container {
    margin-left: auto;
  }

  button {
    padding-left: 0;
    text-decoration: underline;
  }
`;
